import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface webhookInterface {
    id: number
    companyId: number
    url: string
    types: {
        [key: string]: {
            [key: string]: boolean
        }
    }
    secret: string
}

export interface webhookFormInterface {
    url: string
    types: { [key: string]: boolean }
}

interface fetchWebhooksResponse {
    webhooks: webhookInterface[]
    types: string[]
}

interface WebhooksApiReturn {
    fetchServiceProviderWebhooks: () => Promise<fetchWebhooksResponse>
    fetchMerchantWebhooks: (merchantId: number) => Promise<fetchWebhooksResponse>
    createServiceProviderWebhook: (data: webhookFormInterface) => Promise<webhookInterface>
    createMerchantWebhook: (merchantId: number, data: webhookFormInterface) => Promise<webhookInterface>
    updateWebhook: (webhookId: number, data: webhookFormInterface) => Promise<webhookInterface>
    deleteWebhook: (webhookId: number) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): WebhooksApiReturn => ({
    fetchServiceProviderWebhooks: async (): Promise<fetchWebhooksResponse> => {
        const response = await axios.get<{
            webhooks: webhookInterface[]
            types: string[]
        }>('/api/webhooks');

        return response.data;
    },

    fetchMerchantWebhooks: async (merchantId: number): Promise<fetchWebhooksResponse> => {
        const response = await axios.get<fetchWebhooksResponse>(`/api/merchants/${merchantId}/webhooks`);

        return response.data;
    },

    createServiceProviderWebhook: async (data: webhookFormInterface): Promise<webhookInterface> => {
        const response = await axios.post<{ webhook: webhookInterface }>('/api/webhooks', { url: data.url, types: data.types });

        return response.data.webhook;
    },

    createMerchantWebhook: async (merchantId: number, data: webhookFormInterface): Promise<webhookInterface> => {
        const response = await axios.post<{ webhook: webhookInterface }>(`/api/merchants/${merchantId}/webhooks`, { url: data.url, types: data.types });

        return response.data.webhook;
    },

    updateWebhook: async (webhookId: number, data: webhookFormInterface): Promise<webhookInterface> => {
        const response = await axios.put<{ webhook: webhookInterface }>(`/api/webhooks/${webhookId}`, { url: data.url, types: data.types });

        return response.data.webhook;
    },

    deleteWebhook: async (webhookId: number): Promise<void> => {
        await axios.delete(`/api/webhooks/${webhookId}`);
    },
});
